<div class="screen">

    <!-- HEADER -->
    <div class="header">
    </div>
  
    <!-- HERO SECTION -->
    <div class="hero">
  
      <div class="circle">
  
        <img
          src="assets/blocked-wallet.png"
          class="illustration"
          alt="warning"
        />
  
      </div>
  
    </div>
  
    <!-- TEXT -->
    <div class="text-block">
      <div class="title">Limit reached</div>
  
      <div class="subtitle">
        You've hit your transaction limit. Visit your nearest MTN Service Centre for help updating your limit.
      </div>
    </div>
  
    <!-- BUTTON -->
    <footer class="screen-footer">
      <button
      pButton
      label="CLOSE"
      class="retry-btn"
      (click)="retry()"
    ></button>
    </footer>
  
  </div>
  ``